import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import MenuLandingPage from "../../Menu/views/MenuLandingPage";
import { signOut } from "../../signin/helper/signInHelper";
import { getSessionData } from "../helper/baseHelper";
import SessionTimeout from "./SessionTimeout";
import history from "../../../../history";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    marginLeft: "5%",
  },
}));

export default function Base({
  showBaseMenu,
  menuItems,
  hideHomeButton,
  hideDrawer,
  children,
  hidePharmacyButton,
  title,
  showAppsIcon,
  showUserManagement,
}) {
  const classes = useStyles();
  const [isAuthenticated, setAuth] = useState([]);
  const [modules, setModules] = useState([]);

  const handleClick = () => {
    setAuth(!isAuthenticated);
    signOut();
    history.push("/signIn");
  };

  useEffect(() => {
    if (sessionStorage.aimsadmintoken) {
      const userModules = JSON.parse(getSessionData({ key: "userModules" }));
      setModules(userModules);
      setAuth(true);
    } else {
      setAuth(false);
    }
  }, []);

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <>
      <MenuLandingPage
        showBaseMenu={showBaseMenu}
        showUserManagement={showUserManagement}
        hideDrawer={hideDrawer}
        menuItems={menuItems}
        modules={modules}
        hideHomeButton={hideHomeButton}
        hidePharmacyButton={hidePharmacyButton}
        title={title}
        showAppsIcon={showAppsIcon}
      />
      <Container
        maxWidth="xl"
        className={classes.container}
        style={{ marginLeft: showBaseMenu ? "5%" : "0%" }}
      >
        <SessionTimeout
          isAuthenticated={isAuthenticated}
          logOut={handleClick}
        />
        {children}
      </Container>
    </>
  );
}
